'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ByArtistName = require('components/ByArtistName/ByArtistName');

var _ByArtistName2 = _interopRequireDefault(_ByArtistName);

var _TextLine = require('components/TextLine/TextLine');

var _TextLine2 = _interopRequireDefault(_TextLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AlbumItemInfo.scss');

var AlbumItemInfo = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumItemInfo, _PureComponent);

  function AlbumItemInfo() {
    (0, _classCallCheck3.default)(this, AlbumItemInfo);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemInfo.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItemInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album,
          overflow = _props.overflow,
          artistClass = _props.artistClass;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.info, className) },
        _react2.default.createElement(
          _TextLine2.default,
          { className: styles.albumName, overflow: overflow },
          album.albumName
        ),
        _react2.default.createElement(
          _TextLine2.default,
          { className: (0, _bind2.default)(styles.artistName, artistClass), title: album.artist_name, overflow: overflow },
          _react2.default.createElement(_ByArtistName2.default, { artistName: album.artist_name })
        )
      );
    }
  }]);
  return AlbumItemInfo;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  artistClass: _propTypes2.default.string,
  className: _propTypes2.default.string,
  overflow: _propTypes2.default.bool
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = AlbumItemInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemInfo/AlbumItemInfo.js
// module id = 811
// module chunks = 1